import React from 'react';

const Privacy = () => (
  <div style={{ padding: '2rem', fontFamily: 'Lato, sans-serif', maxWidth: '900px', margin: '0 auto' }}>
    <h1>Isadoran Creed — Privacy Policy</h1>
    <p><em>Last updated: 2025-08-26</em></p>

    <h2>1. What We Collect</h2>
    <p>Account info you provide to our site; TikTok identifiers (e.g., open_id), access/refresh tokens, and basic profile fields granted by scope <code>user.info.basic</code>. Operational logs and posting metadata.</p>

    <h2>2. How We Use Data</h2>
    <p>To authenticate your account, show your connected profile, and publish content you request via the TikTok APIs. We do not sell your data.</p>

    <h2>3. Storage & Security</h2>
    <p>Tokens are stored server-side, encrypted at rest, and transmitted over HTTPS. Access is restricted to authorized systems.</p>

    <h2>4. Sharing</h2>
    <p>We share data only with service providers necessary to operate the Service (e.g., hosting, databases) and with TikTok as required to fulfill your requests.</p>

    <h2>5. Your Choices</h2>
    <p>You can disconnect at any time. Email contact@isadorancreed.com to request deletion of your account data from our systems.</p>

    <h2>6. Children</h2>
    <p>Service is not intended for children under 13 (or as defined by local law).</p>

    <h2>7. Changes</h2>
    <p>We may update this Policy. Material changes will be posted on this page.</p>

    <h2>8. Contact</h2>
    <p>contact@isadorancreed.com</p>
  </div>
);

export default Privacy;


